(function () {
  'use strict';

  function init() {
    // INLINE SVG
    jQuery('img.svg').each(function (i) {
      var $img = jQuery(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      jQuery.get(imgURL, function (data) {
        var $svg = jQuery(data).find('svg');
        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }
        $svg = $svg.removeAttr('xmlns:a');
        $img.replaceWith($svg);
      }, 'xml');
    });// END OF INLINE SVG

    // mainLayout();
    runSlider();
    func();

  } init(); // END OF init()

  function mainLayout() {
    var $headerH = $('header').outerHeight(),
      $footerH = $('footer').height();
    $('main').css({ 'min-height': 'calc(100vh - ' + $footerH + 'px)', 'padding-top': +$headerH + 'px' });
  }

  function runSlider() {
    $('.slider').each(function () {
      var t = $(this),
          child = t.children().length,
          item = t.attr('data-items') ? t.attr('data-items') : 1,
          loops = t.attr('data-loop') && t.attr('data-loop') == "false" ? false : true;
      var w = $(window).width();
      if( child > 1 ) {
        t.addClass('owl-carousel').removeClass('row');
          t.owlCarousel({
            navText: ["<span></span>", "<span></span>"],
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
            items: item,
            loop: false,
            autoWidth: true,
            nav: true,
            dots: false,
            autoplay: false,
            margin: 25,
            autoplayTimeout: 6000,
            autoplaySpeed: 1500,
            smartSpeed: 1500
        });
      }else {
        t.addClass('no-slider row');
        t.trigger('destroy.owl.carousel').removeClass('owl-carousel');
        t.removeClass('owl-loaded');
        t.find('.owl-stage-outer').children().unwrap();
      }

    });

    function slickMobile() {
      $('.slick-mobile').each(function () {
        var w = $(window).width();
        var t = $(this);
        if(w < 500){
          t.addClass('owl-carousel');
          t.owlCarousel({
            navText: [],
            items: 1,
            loop: false,
            nav: false,
            dots: false,
            autoplay: false,
            stagePadding: 30,
            autoWidth: true
          });
        }
      });
    }slickMobile();
  }// end of runSlider()

  function func() {

    $('.icon-menu').click(function() {
      $('body').toggleClass('mobile-menu-open');
      // $('.has-sub').removeClass('sub-open');
    });

    $('.box-navmobile__close').click(function() {
      $('body').toggleClass('mobile-menu-open');
      // $('.has-sub').removeClass('sub-open');
  })

    $('.account-user:not(.mobile)').click(function(){
      $('body').toggleClass('usracnt-open');
    });

    if($('.join-webinar').length > 0){
      $('.footer').addClass('minus-top');
    }

    // STICKY HEADER
    if ($('.header').length > 0) {
      var header = $('.header'),
        pos = 10;
      $(window).on('scroll', function () {
        var scroll = $(window).scrollTop();
        if (scroll >= pos) {
          header.addClass('sticky');
          $('body').addClass('header-stick');
        } else {
          header.removeClass('sticky');
          $('body').removeClass('header-stick');
        }
      });
    }

    $('.marquee').each(function () {
      var $t = $(this);
      $t.marquee({
        speed: 100,
        gap: 0,
        delayBeforeStart: 0,
        direction: 'left',
        startVisible: true,
        duplicated: true,
        pauseOnHover: true
      })
    })

    $('.accordion').each(function () {
      var $t = $(this),
        $card = $t.find('.card');

      $card.each(function () {
        var $el = $(this),
          $head = $el.find('.card-header'),
          $body = $el.find('.card-body');

        $head.click(function () {
          $card.not($el).removeClass('open');
          $el.toggleClass('open');
        });
      });
    });

    // Bootsrap Select
    $('.select').each(function(){
      $(this).selectpicker();
    });

    $('.drop-box').each(function(){
      var t     = $(this),
          inputs = t.find('#photo'),
          preview = t.find('.image-preview'),
          del   = t.find('.del-btn');

      function readURL(input, prev) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
              preview.css('background-image', 'url(' + e.target.result + ')');
              preview.fadeIn();
              del.fadeIn();
            }

            reader.readAsDataURL(input.files[0]);
        }
      }

      $("#photo").change(function(){
        readURL(this);
        console.log('jalan')
      });

      del.click(function(){
        $(this).fadeOut();
        preview.fadeOut();
        preview.css('background-image', '');
        inputs.val('');
      })

    });

    // Copy to clipboard
    $('.can-copy').each(function(){
      var t = $(this),
          fc = t.find('.form-control'),
          cp = t.find('.copy');
      $(cp).click(function(){
        $(fc).select();
        document.execCommand("copy");
      });
    })

    // Calendar
    $('.box-calendar').each(function(){
      var t = $(this);
      t.calendar();
    });

    // Nav to selects
    $('.jadwal__filter ul').each(function(){
      var t = $(this),
          a = t.find('a'),
          html = "",
          select = $('<select class="select select-nav" title="Filter">'),
          sm = $('#jadwalFilter_mobile'),
          st = $("<div class='select-filter' />");

        a.each(function(){
          var link = $(this).attr('href');
          //   console.log(link);
          if($(this).hasClass('active')){
              html+="<option value='"+link+"' selected>"+$(this).text()+"</option>";
          }else{
              html+="<option value='"+link+"'>"+$(this).text()+"</option>";
          }

        })

      select.html(html);
      st.append(select);
      st.insertAfter(sm);

      $('select.select').selectpicker({
        style: 'select-control',
        width: '100%',
        size: 5
      });
  });




  }// END of func()

})();
